import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { isScheduledAutomationComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class ScheduledAutomationFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<API.ScheduledAutomationComponentFragment>,
  ) {}

  matchesComponent(component: API.AnyComponent, _reservedIds: Array<string>): boolean {
    return isScheduledAutomationComponent(component);
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
